import { Box, Image, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconAssets } from 'src/config';

interface Props {
	text: string;
	description: string;
	href: string;
	ghost?: boolean;
	disabled?: boolean;
}

export const RedirectButton: FC<Props> = ({ text, description, href, ghost = false, disabled = false }) => {
	const navigate = useNavigate();

	const handleClick = () => {
		if (!disabled) {
			navigate(href);
		}
	};

	return (
		<Box
			pos="relative"
			p="18px 30px"
			w={{ base: '100%', md: '300px' }}
			_hover={{ opacity: '0.9' }}
			bg={ghost ? 'transparent' : 'cartridge.red'}
			cursor={disabled ? 'default' : 'pointer'}
			filter={disabled ? 'grayscale(1)' : ''}
			border="1px solid"
			borderColor="cartridge.red"
			borderRadius="4px"
			onClick={handleClick}
		>
			<Text
				fontSize="20px"
				fontWeight="bold"
			>
				{text}
			</Text>
			<Text
				fontSize="13px"
				color={ghost ? '#5A5E68' : '#222222'}
			>
				{description}
			</Text>
			<Image
				pos="absolute"
				right="25px"
				top="24px"
				src={IconAssets.chevronRight}
			/>
		</Box>
	);
};
